export default __webpack_public_path__ + "static/media/for.e89c04cc.png";